import React from "react"
import { createRoot } from "react-dom/client"
import * as Sentry from "@sentry/react"
import { App } from "./components/App"
import "./i18n"
import "@inkblot-therapy/squid/output/styles.css"
import "./index.css"
import "./variables.css"
import reportWebVitals from "./reportWebVitals"
const LogRocket = require("logrocket/setup")({
  sdkServer: "https://logrocket.tranquility.app",
  ingestServer: "https://logrocket.tranquility.app",
})

if (document.location.href.includes("-staging"))
  LogRocket.init("tranquility/referral-staging")
else if (document.location.href.includes("referral.tranquility.app")) {
  LogRocket.init("tranquility/referral-production")
}

Sentry.init({
  dsn: "https://f7bf5986d9bd46ac9b3da30b73d7fff6@o161804.ingest.sentry.io/4505160422653952",
})

const container = document.getElementById("root")

const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
